import { useEffect } from "react";
import { useNavigate, useLocation, Link as RouterLink } from "react-router-dom";
import { Box, Container, Typography, Paper, Button } from "@mui/material";
import { useAuth } from "../../hooks";
import { CheckCircleOutline } from "@mui/icons-material";
import config from "../../config/environment";
import heightenLogo from "../../assets/images/heighten-logo.png";

const ResetPasswordSentPage = () => {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const email = (location.state as any)?.email || "";

  useEffect(() => {
    // If user is already authenticated, redirect to home page
    if (isAuthenticated) {
      navigate("/", { replace: true });
    }

    // If no email in state, redirect to request page
    if (!email) {
      navigate("/auth/reset-password-request", { replace: true });
    }
  }, [isAuthenticated, navigate, email]);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        backgroundColor: "#1e293b", // slate-800 to match sidebar
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Container maxWidth="xs">
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          {/* Logo */}
          <Box sx={{ mb: 3 }}>
            <Box
              component={RouterLink}
              to="/"
              sx={{ display: "inline-block", textDecoration: "none" }}
            >
              <Box
                component="img"
                src={heightenLogo}
                alt="Heighten Management"
                sx={{ cursor: "pointer" }}
              />
            </Box>
          </Box>

          <Paper
            elevation={3}
            sx={{ p: 4, width: "100%", textAlign: "center" }}
          >
            <CheckCircleOutline color="success" sx={{ fontSize: 60, mb: 2 }} />

            <Typography component="h1" variant="h5" gutterBottom>
              Check Your Email
            </Typography>

            <Typography variant="body1" sx={{ mb: 3 }}>
              We've sent a password reset link to:
            </Typography>

            <Typography variant="body1" fontWeight="bold" sx={{ mb: 4 }}>
              {email}
            </Typography>

            <Typography variant="body2" color="textSecondary" sx={{ mb: 4 }}>
              If you don't see the email in your inbox, please check your spam
              folder. The link will expire in 30 minutes.
            </Typography>

            <Button
              component={RouterLink}
              to="/auth/login"
              variant="contained"
              fullWidth
              sx={{ mt: 2 }}
            >
              Return to Login
            </Button>
          </Paper>

          {/* Footer */}
          <Typography
            variant="caption"
            align="center"
            sx={{ mt: 4, color: "white" }}
          >
            © 2025 {config.app.tagline}. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default ResetPasswordSentPage;
